import React, {useEffect, useState} from 'react';
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Radio,
    RadioGroup,
} from '@mui/material';
import {t} from 'i18next';
import makeStyles from '@mui/styles/makeStyles';
import AgyleAccordion from '../../../components/ui/accordion/agyleAccordion';
import moment from 'moment';
import {useDispatch, useSelector} from 'react-redux';
import Formatter from '../../../util/formatter';
import {user} from '../../../store/reducers/user';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import Button from '@mui/material/Button';
import config from '../../../app/config';
import AgyleDatePicker from '../../../components/ui/fields/agyleDatePicker';
import Divider from '@mui/material/Divider';
import AgyleButton from '../../../components/ui/buttons/agyleButton';
import useDict from '../../../hooks/useDict';
import AgyleDictionaryField from '../../../components/ui/selector/agyleDictionaryField';
import ObservationTable from '../../../components/observation/observationTable';
import {openPatientForm} from '../../../store/reducers/patientContext';
import Notes from '../../../util/notes';
import NewBodyMapNote from '../../../components/notes/component/newBodyMapNote';
import useOpenState from '../../../hooks/useOpenState';
import AddIcon from '@mui/icons-material/Add';
import {agylePref} from '../../../store/reducers/preferences';

const useStyles = makeStyles((theme) => ({

    divider: {
        width: '100%',
        alignItems: 'center',
        margin: "5px",
    },

    textField: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

    radio: {
        width: '100%',
        minWidth: '100%',
    },

    mandatory: {
        fontWeight: 'bold',
        color: '#e06666',
    },

    clearButton:{
        border: '1px solid #2180f7',
        height: '25px',
        placeSelf: "center",
    },

    error: {
        color: theme.palette.error.main,
    },

    linkInfo: {
        color: "#2180f7",
        textIndent: '10%',
        padding: '10px !important',
    },
    observations: {
        width: 'auto',
    },

}));

const FrailtySDECForm = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const userObject = useSelector(user);
    const tester = Formatter.formatUserFullName(userObject);
    const agylePreference = useSelector(agylePref);

    const [isBodyMapOpen, openBodyMap, closeBodyMap] = useOpenState(false, true);
    const [defaultNoteType, setDefaultNoteType] = useState(agylePreference.defaultNoteType);

    const handleCloseBodyMapEditor = (noteChange = false) => {
        closeBodyMap();
    };

    const addBodyMap = () => {
        openBodyMap();
    };

    //dicts
    const [accommodationType] = useDict('CgaAccommodationType');
    const [toiletLocation] = useDict('CgaToiletLocation');
    const [administeredMedication] = useDict('CgaAdministeredMedication');
    const [patientFalls] = useDict('CgaPatientFalls');
    const [bathroomLocation] = useDict('CgaBathroomLocation');
    const [livesWith] = useDict('CgaLivesWith');
    const [bedType] = useDict('CgaBedType');
    const [chairType] = useDict('CgaChairType');
    const [foodConsistency] = useDict('CgaFoodConsistency');
    const [fluids] = useDict('CgaFluids');

    const [accordionExpandedState, setAccordionExpandedState] = useState({
        visitInformation: true,
        lastingPowerOfAttorney: false,
        complaints: false,
        administration: false,
        falls: false,
        osteoporosis: false,
        moodAndMemory: false,
        socialHistory: false,
        mobilityAndTransfers: false,
        activitieOfDailyLiving: false,
        additionalInformation: false,
        communication: false,
        dietNutritionAndSwallowing: false,
        vitalObservation: false,
        physicalExamination: false,
        systems: false,
        problems: false,
    });

    const [frailtySDECForm, setFrailtySDECForm] = useState({
        attendanceDate: "",
        attendanceTime:  "",
        noOfEDAttendance: "",
        noOfEDAdmission: "",
        advancedCarePlan: "",
        assessmentInitiatedBy:  "",
        lastingPowerOfAttorney: "",
        lastingPowerOfAttorneyText: "",
        presentingComplaint: "",
        historyOfPresentingComplaint:  "",
        pastMedicalHistory: "",
        allergies:  "",
        medication: "",
        administrationChooseItem: null,
        administrationText: "",
        administrationConcordance: "",
        fallsNoInpastYear: null,
        descriptionOfFalls: "",
        symptoms: {
            dizziness: false,
            sweat: false,
            palpitations: false,
            loss: false,
        },
        osteoporosisHistoryOfFractures: "",
        riskFactors: "",
        patientOnBoneProtection: "",
        patientOnBoneProtectionText: "",
        patientRadioDetails: {
            historyOfFractures: false,
            riskFactors: false,
            notOnBone: false,
        },
        diagnosisOfDementia: "",
        furtherDetails: "",
        alertness:  "",
        alertnessScore: "",
        delirium4at: "",
        delirium4atScore:  "",
        attention:  "",
        attentionScore:  "",
        fluctuation:  "",
        fluctuationScore:  "",
        total:  "",
        delirium4atdropdown: "",
        mood: "",
        accomodation: null,
        accomodationText: "",
        stairs: "",
        toilet: null,
        bathroom: null,
        livesWith: null,
        socialHistoryText: "",
        lifeSpace: "",
        walkingAid: {
            none: false,
            stick: false,
            crutches: false,
            wheeled: false,
            ross: false,
            stand: false,
            hoist: false,
            bed: false,
        },
        bedType: null,
        equipment: "",
        bedTransferIssues: "",
        chairType: null,
        difficulties: "",
        toiletEquipment: "",
        carers: "",
        agency: "",
        washAndDressing: "",
        toiletingIncludingContinence: "",
        meals: "",
        shopping: "",
        domesticTasks: "",
        rolesAndOccupation: "",
        careLine: "",
        keySafe: "",
        code: "",
        pressureAreas: "",
        mattress: "",
        cushion: "",
        hearing: "",
        vision: "",
        speechAndLanguage: "",
        preferredMethodOfCommunication: "",
        height: "",
        weight: "",
        bmi: "",
        signsOfVisibleWeightLoss: "",
        reducedAppetite: "",
        reducedAppetiteText: "",
        reportedSwallowingDifficulty: "",
        reportedSwallowingDifficultyText: "",
        foodConsistency: null,
        fluids: null,
        physicalExamination: {
            jaundice: false,
            anaemia: false,
            clubbing: false,
            cyanosis: false,
            oedma: false,
            lyphadenopathy: false,
        },
        generalComments: "",
        cardiovascular: "",
        respiratoryText: "",
        gastrointestinalText: "",
        musculoskeletalText: "",
        neurologyText: "",
        bloodResultsText: "",
        patientsPerceivedProblems: "",
        carersPerceivedProblems: "",
        problemList: "",
        treatmentPlanCfs: "",
        treatmentPlanText: "",
    })

    useEffect(() => {
        if(props.data){
            setFrailtySDECForm(props.data)
        } else {
            setFrailtySDECForm({
                attendanceDate: props.patient?.admission?.startDate ? moment(props.patient.admission.startDate).format(config.defaultDateFormat) : null,
                attendanceTime: props.patient?.admission?.startDate ? moment(props.patient.admission.startDate).format(config.defaultDateTimeFormat) : null,
                noOfEDAttendance: "",
                noOfEDAdmission: "",
                advancedCarePlan: "",
                assessmentInitiatedBy: props.patient?.currentClinician?.__description ? props.patient?.currentClinician?.__description : "",
                lastingPowerOfAttorney: "",
                lastingPowerOfAttorneyText: "",
                presentingComplaint: "",
                historyOfPresentingComplaint: props.patient?.clerking?.historicPresentingComplaint ? props.patient?.clerking?.historicPresentingComplaint : props.patient?.studies?.seeAndTreat?.historyOfPresentingComplaint ? props.patient?.studies?.seeAndTreat?.historyOfPresentingComplaint : props.patient?.triage?.historicPresentingComplaint ? props.patient?.historicPresentingComplaint?.allergies : "",
                pastMedicalHistory: props.patient?.clerking?.pastMedicalHistory ? props.patient?.clerking?.pastMedicalHistory : props.patient?.studies?.seeAndTreat?.pastMedicalHistory ? props.patient?.studies?.seeAndTreat?.pastMedicalHistory : props.patient?.triage?.pastMedicalHistory ? props.patient?.triage?.pastMedicalHistory : "",
                allergies: props.patient?.clerking?.allergies ? props.patient?.clerking?.allergies : props.patient?.studies?.seeAndTreat?.allergiesAndReactions ? props.patient?.studies?.seeAndTreat?.allergiesAndReactions : props.patient?.triage?.allergies ? props.patient?.triage?.allergies : "",
                medication: "",
                administrationChooseItem: null,
                administrationText: "",
                administrationConcordance: "",
                fallsNoInpastYear: null,
                descriptionOfFalls: "",
                symptoms: {
                    dizziness: false,
                    sweat: false,
                    palpitations: false,
                    loss: false,
                },
                osteoporosisHistoryOfFractures: "",
                riskFactors: "",
                patientOnBoneProtection: "",
                patientOnBoneProtectionText: "",
                patientRadioDetails: {
                    historyOfFractures: false,
                    riskFactors: false,
                    notOnBone: false,
                },
                diagnosisOfDementia: "",
                furtherDetails: "",
                alertness: props.patient?.studies?.delirium?.list[0]?.values.cat1.text ? props.patient.studies.delirium.list[0].values.cat1.text : "",
                alertnessScore: props.patient?.studies?.delirium?.list[0]?.values.cat1.score ? props.patient.studies.delirium.list[0].values.cat1.score : "",
                delirium4at: props.patient?.studies?.delirium?.list[0]?.values.cat2.text ? props.patient.studies.delirium.list[0].values.cat2.text : "",
                delirium4atScore: props.patient?.studies?.delirium?.list[0]?.values.cat3.score ? props.patient.studies.delirium.list[0].values.cat2.score : "",
                attention: props.patient?.studies?.delirium?.list[0]?.values.cat3.text ? props.patient.studies.delirium.list[0].values.cat3.text : "",
                attentionScore: props.patient?.studies?.delirium?.list[0]?.values.cat3.score ? props.patient.studies.delirium.list[0].values.cat3.score : "",
                fluctuation: props.patient?.studies?.delirium?.list[0]?.values.cat4.text ? props.patient.studies.delirium.list[0].values.cat4.text : "",
                fluctuationScore: props.patient?.studies?.delirium?.list[0]?.values.cat4.score ? props.patient.studies.delirium.list[0].values.cat4.score : "",
                total: props.patient?.studies?.delirium?.list[0]?.totalScore ? props.patient.studies.delirium.list[0].totalScore : "",
                delirium4atdropdown: "",
                mood: "",
                accomodation: null,
                accomodationText: "",
                stairs: "",
                toilet: null,
                bathroom: null,
                livesWith: null,
                socialHistoryText: "",
                lifeSpace: "",
                walkingAid: {
                    none: false,
                    stick: false,
                    crutches: false,
                    wheeled: false,
                    ross: false,
                    stand: false,
                    hoist: false,
                    bed: false,
                },
                bedType: null,
                equipment: "",
                bedTransferIssues: "",
                chairType: null,
                difficulties: "",
                toiletEquipment: "",
                carers: "",
                agency: "",
                washAndDressing: "",
                toiletingIncludingContinence: "",
                meals: "",
                shopping: "",
                domesticTasks: "",
                rolesAndOccupation: "",
                careLine: "",
                keySafe: "",
                code: "",
                pressureAreas: "",
                mattress: "",
                cushion: "",
                hearing: "",
                vision: "",
                speechAndLanguage: "",
                preferredMethodOfCommunication: "",
                height: "", //props.patientAddData?.other?.nutritionScreen[0]?.height ? props.patientAddData?.other?.nutritionScreen[0]?.height : "",
                weight: "", //props.patientAddData?.other?.nutritionScreen[0]?.weight ? props.patientAddData?.other?.nutritionScreen[0]?.weight : "",
                bmi: "", //props.patientAddData?.other?.nutritionScreen[0]?.bmi ? props.patientAddData?.other?.nutritionScreen[0]?.bmi : "",
                signsOfVisibleWeightLoss: "",
                reducedAppetite: "",
                reducedAppetiteText: "",
                reportedSwallowingDifficulty: "",
                reportedSwallowingDifficultyText: "",
                foodConsistency: null,
                fluids: null,
                physicalExamination: {
                    jaundice: false,
                    anaemia: false,
                    clubbing: false,
                    cyanosis: false,
                    oedma: false,
                    lyphadenopathy: false,
                },
                generalComments: "",
                cardiovascular: "",
                respiratoryText: "",
                gastrointestinalText: "",
                musculoskeletalText: "",
                neurologyText: "",
                bloodResultsText: "",
                patientsPerceivedProblems: "",
                carersPerceivedProblems: "",
                problemList: "",
                treatmentPlanCfs: "",
                treatmentPlanText: "",
            })
        }
    },[])

    useEffect(() => {
        if (props.onSubmitFunction) {
            props.onSubmitFunction(handleSaveForm);
        }
        if (props.onDisableSubmit) {
            props.onDisableSubmit(isSubmitDisabled() || props.disableSave);
        }
    }, [frailtySDECForm, userObject, props.disableSave]);

    const handleChangeRadio = (event) => {
        const {name, value} = event.target;
        setFrailtySDECForm(pr => ({
            ...pr,
                [name]:value
            }))
    };

    const handleChangeTextField = (event) => {
        const {name, value} = event.target;
        setFrailtySDECForm(pr => ({
            ...pr,
            [name]:value
        }))
    };

    const handleChangeCheckbox = (event, objectKey) => {
        const {name, checked} = event.target;
        setFrailtySDECForm((pr) =>
            ({
                ...pr,
                [objectKey]: {
                    ...pr[objectKey],
                    [name]:checked
                }
            }));
    };

    const handleChangeAccordion = (param) => {
        setAccordionExpandedState((pr) =>
            ({
                ...pr,
                [param]:!pr[param]
            }));
    };

    const handleChangeNull = (name) => {
        setFrailtySDECForm(pr => ({
            ...pr,
            [name]: ""
        }));
    };

    const handleChange = (event) => {
        const {name, value} = event.target;
        setFrailtySDECForm(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleChangeDict = (name, value) => {
        handleChange({target: {name, value}});
    };

    const isSubmitDisabled = () => {

        let submitDisabled = false;

        const requiredFields = [
            frailtySDECForm.attendanceDate,
            frailtySDECForm.attendanceTime,
            frailtySDECForm.noOfEDAttendance,
            frailtySDECForm.noOfEDAdmission,
            frailtySDECForm.advancedCarePlan,
            frailtySDECForm.historyOfFractures,
            frailtySDECForm.diagnosisOfDementia,
            frailtySDECForm.furtherDetails,
            frailtySDECForm.delirium4at,
            frailtySDECForm.mood,
            frailtySDECForm.patientsPerceivedProblems,
            frailtySDECForm.carersPerceivedProblems,
            frailtySDECForm.problemList,
            frailtySDECForm.treatmentPlanText,
        ];

        if (requiredFields.some(field => field === "")) {
            submitDisabled = true;
        }
        return submitDisabled;
    };

    const handleSaveForm = () => {
        const objectToSave = {
            ...frailtySDECForm,
            timeStamp: moment().toISOString(),
            by: tester,
        }
      let dataArray = [{
          name: "studies.frailtySDECForm",
          value: objectToSave,
          noteType: "studies.frailtySDECForm",
          noteToAdd: Notes.getFrailtySDECNote(objectToSave),
      }]
        props.onChange(dataArray);
    };

    const renderFormLabel = (condition, labelKey) => (
        <FormLabel className={condition ? classes.label : classes.mandatory}>
            {t(labelKey)}{!condition && '*'}
        </FormLabel>
    );

    const buttons = () => {
        const buttons = [];

            buttons.push(
                <AgyleButton
                    variant="contained"
                    disabled={props.workflowDisabled}
                    style={{margin: '0px 5px 0px 5px'}}
                    onClick={() => dispatch(openPatientForm('abbeyPainScaleForm'))}
                >
                    {t('Fill Abbey Pain Scale Form')}
                </AgyleButton>,
            )

        return buttons;
    }

    return (
            <>
                <AgyleAccordion
                    expanded={accordionExpandedState.visitInformation}
                    onChange={()=>handleChangeAccordion("visitInformation")}
                    label="Visit Information"
                >
                     <Grid container spacing={2}>
                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.attendanceDate, "Attendance Date")}
                        </Grid>
                        <Grid item xs={3}>
                            <AgyleDatePicker
                                type="date"
                                error={!frailtySDECForm.attendanceDate}
                                value={frailtySDECForm.attendanceDate}
                                onChange={(param) => {setFrailtySDECForm((pr) =>
                                    ({
                                    ...pr,
                                    attendanceDate: param
                                }))}}
                            />
                        </Grid>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.attendanceTime, "Attendance Time")}
                        </Grid>
                        <Grid item xs={3}>
                            <AgyleDatePicker
                                type="time"
                                error={!frailtySDECForm.attendanceTime}
                                value={frailtySDECForm.attendanceTime}
                                onChange={(param) => {setFrailtySDECForm((pr) =>
                                    ({
                                    ...pr,
                                    attendanceTime: param
                                }))}}
                            />
                        </Grid>
                        <Grid item xs={3.25}>
                            {renderFormLabel(frailtySDECForm.noOfEDAttendance, "No of ED attendance in the past year")}
                        </Grid>
                        <Grid item xs={8.75}>
                            <AgyleTextField
                                fullWidth
                                name="noOfEDAttendance"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.noOfEDAttendance}
                                variant="outlined"
                                error={!frailtySDECForm.noOfEDAttendance}
                                noBorder={false}
                            />
                        </Grid>
                        <Grid item xs={3.25}>
                            {renderFormLabel(frailtySDECForm.noOfEDAdmission, "No of ED admission in the past year")}
                        </Grid>
                        <Grid item xs={8.75}>
                        <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="noOfEDAdmission"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.noOfEDAdmission}
                                variant="outlined"
                                error={!frailtySDECForm.noOfEDAdmission}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.advancedCarePlan, "Advanced Care Plan")}
                        </Grid>
                        <Grid item xs={9}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="advancedCarePlan"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.advancedCarePlan}
                                    className={!frailtySDECForm.advancedCarePlan && classes.error}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio className={!frailtySDECForm.advancedCarePlan && classes.error}/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio className={!frailtySDECForm.advancedCarePlan && classes.error}/>}
                                        label={t('No')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("advancedCarePlan")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Assessment initiated by")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="assessmentInitiatedBy"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.assessmentInitiatedBy}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.lastingPowerOfAttorney}
                    onChange={()=>handleChangeAccordion("lastingPowerOfAttorney")}
                    label="Lasting Power Of Attorney"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.lastingPowerOfAttorney, "Lasting Power Of Attorney")}
                        </Grid>
                        <Grid item xs={9}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="lastingPowerOfAttorney"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.lastingPowerOfAttorney}
                                    className={!frailtySDECForm.lastingPowerOfAttorney && classes.error}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio className={!frailtySDECForm.lastingPowerOfAttorney && classes.error}/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio className={!frailtySDECForm.lastingPowerOfAttorney && classes.error}/>}
                                        label={t('No')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("lastingPowerOfAttorney")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        {frailtySDECForm.lastingPowerOfAttorney === "yes" && (
                            <>
                                <Grid item xs={12}>
                                    <AgyleTextField
                                        noBorder={false}
                                        fullWidth
                                        name="lastingPowerOfAttorneyText"
                                        maxRows={25}
                                        label={t("Click or tap here to enter text")}
                                        multiline
                                        onChange={handleChangeTextField}
                                        value={frailtySDECForm.lastingPowerOfAttorneyText}
                                        variant="outlined"
                                    />
                                </Grid>
                            </>)}
                    </Grid>
                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.complaints}
                    onChange={()=>handleChangeAccordion("complaints")}
                    label="Complaints"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.presentingComplaint, "Presenting Complaint")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="presentingComplaint"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.presentingComplaint}
                                variant="outlined"
                                error={!frailtySDECForm.presentingComplaint}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.historyOfPresentingComplaint, "History Of Presenting Complaint")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="historyOfPresentingComplaint"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.historyOfPresentingComplaint}
                                variant="outlined"
                                error={!frailtySDECForm.historyOfPresentingComplaint}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.pastMedicalHistory, "Past Medical History")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="pastMedicalHistory"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.pastMedicalHistory}
                                variant="outlined"
                                error={!frailtySDECForm.pastMedicalHistory}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.allergies, "Allergies")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="allergies"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.allergies}
                                variant="outlined"
                                error={!frailtySDECForm.allergies}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.medication, "Medication")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="medication"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.medication}
                                variant="outlined"
                                error={!frailtySDECForm.medication}
                            />
                        </Grid>
                    </Grid>
                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.administration}
                    onChange={()=>handleChangeAccordion("administration")}
                    label="Administration"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <FormLabel className={classes.label}>{t("Administered medication?")}</FormLabel>
                        </Grid>
                        <Grid item xs={6}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('administrationChooseItem', val)}
                                options={administeredMedication}
                                value={frailtySDECForm.administrationChooseItem}
                                noBorder={false}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="administrationText"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.administrationText}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Concordance?")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="administrationConcordance"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.administrationConcordance}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.falls}
                    onChange={()=>handleChangeAccordion("falls")}
                    label="Falls"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("No falls in past year")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('fallsNoInpastYear', val)}
                                options={patientFalls}
                                value={frailtySDECForm.fallsNoInpastYear}
                                getOptionLabel={option => option.description}
                                noBorder={false}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Description Of Falls")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="descriptionOfFalls"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.descriptionOfFalls}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Symptoms")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "symptoms")}
                                        checked={frailtySDECForm.symptoms.dizziness}
                                        name="dizziness"
                                    />
                                }
                                label="Dizziness"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "symptoms")}
                                        checked={frailtySDECForm.symptoms.sweat}
                                        name="sweat"
                                    />
                                }
                                label="Sweat"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "symptoms")}
                                        checked={frailtySDECForm.symptoms.palpitations}
                                        name="palpitations"
                                    />
                                }
                                label="Palpitations"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "symptoms")}
                                        checked={frailtySDECForm.symptoms.loss}
                                        name="loss"
                                    />
                                }
                                label="Loss of consciousness"
                            />
                        </Grid>
                    </Grid>
                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.osteoporosis}
                    onChange={()=>handleChangeAccordion("osteoporosis")}
                    label="Osteoporosis"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.osteoporosisHistoryOfFractures, "History Of Fractures")}
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="osteoporosisHistoryOfFractures"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.osteoporosisHistoryOfFractures}
                                variant="outlined"
                                error={!frailtySDECForm.osteoporosisHistoryOfFractures}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormLabel className={classes.label}>{t("Risk Factors")}</FormLabel>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="riskFactors"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.riskFactors}
                                >
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="copd" control={<Radio/>} label={t('COPD')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="immobility" control={<Radio/>} label={t('Immobility')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="history" control={<Radio/>} label={t('History of falls')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="smoker" control={<Radio/>} label={t('Smoker')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="hypogonadism" control={<Radio/>} label={t('Hypogonadism')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="endocrine" control={<Radio/>} label={t('Endocrine conditions')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="malabsorption" control={<Radio/>} label={t('Malabsorption conditions')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="bmi" control={<Radio/>} label={t('BMI less than 18.5kg/m2')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="previousOsteoporotic" control={<Radio/>} label={t('Previous osteoporotic fragility fracture')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="parentalHip" control={<Radio/>} label={t('Parental hip fracture')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="oralCorticosteroids" control={<Radio/>} label={t('Frequent oral corticosteroids')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="alcohol" control={<Radio/>} label={t('Alcohol - over 14 units per week')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="chronicKidney" control={<Radio/>} label={t('Chronic kidney disease')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="chronicLiver" control={<Radio/>} label={t('Chronic liver failure')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="hypogonadismMenopause" control={<Radio/>} label={t('Hypogonadism including untreated premature menopause')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="rheumatoid" control={<Radio/>} label={t('Rheumatoid arthritis or other inflammatory arthropathies')}
                                        />
                                    </Grid>
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("riskFactors")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Divider className={classes.divider}/>
                        <Grid item xs={12} className={classes.linkInfo}>
                            <FormLabel style={{color: "#2180f7"}}>
                                {t("Further guidance for assessment and treatment of osteoporosis can be found at ")}
                                <a href="https://cks.nice.org.uk" target="_blank" rel="noopener noreferrer" style={{ color: "#2180f7", fontWeight: "bold"}}>
                                    www.cks.nice.org.uk
                                </a>
                            </FormLabel>
                        </Grid>
                        <Divider className={classes.divider}/>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Patient On Bone Protection")}</FormLabel>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="patientOnBoneProtection"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.patientOnBoneProtection}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio/>}
                                        label={t('No')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("patientOnBoneProtection")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="patientOnBoneProtectionText"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.patientOnBoneProtectionText}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "patientRadioDetails")}
                                        checked={frailtySDECForm.patientRadioDetails.historyOfFractures}
                                        name="historyOfFractures"
                                    />
                                }
                                label="Patient has history of fractures"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "patientRadioDetails")}
                                        checked={frailtySDECForm.patientRadioDetails.riskFactors}
                                        name="riskFactors"
                                    />
                                }
                                label="Risk factors present"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "patientRadioDetails")}
                                        checked={frailtySDECForm.patientRadioDetails.notOnBone}
                                        name="notOnBone"
                                    />
                                }
                                label="Patient not on bone protection"
                            />
                        </Grid>
                        <Grid item xs={12} className={classes.linkInfo}>
                            <FormLabel className={classes.linkInfo}>{t("Please check vitamin D and calcium levels")}</FormLabel>
                        </Grid>
                        <Grid item xs={12} className={classes.linkInfo}>
                            <FormLabel className={classes.linkInfo}>{t("Recommend Treatment: please consider cognition, life expectancy and side effects")}</FormLabel>
                        </Grid>
                    </Grid>
                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.moodAndMemory}
                    onChange={()=>handleChangeAccordion("moodAndMemory")}
                    label="Mood and Memory"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.diagnosisOfDementia, "Diagnosis Of Dementia")}
                        </Grid>
                        <Grid item xs={9}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="diagnosisOfDementia"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.diagnosisOfDementia}
                                    className={!frailtySDECForm.diagnosisOfDementia && classes.error}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio className={!frailtySDECForm.diagnosisOfDementia && classes.error}/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio className={!frailtySDECForm.diagnosisOfDementia && classes.error}/>}
                                        label={t('No')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("diagnosisOfDementia")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.furtherDetails, "Further Details")}
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="furtherDetails"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.furtherDetails}
                                variant="outlined"
                                error={!frailtySDECForm.furtherDetails}
                            />
                        </Grid>
                        <Divider className={classes.divider}/>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.alertness, "Alertness")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="alertness"
                                maxRows={25}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.alertness}
                                variant="outlined"
                                error={!frailtySDECForm.alertness}
                            />
                        </Grid>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.delirium4at, "AMT4")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="delirium4at"
                                maxRows={25}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.delirium4at}
                                variant="outlined"
                                error={!frailtySDECForm.delirium4at}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <FormLabel>{t("4AT")}</FormLabel>
                        </Grid>
                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.attention, "Attention")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="attention"
                                maxRows={25}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.attention}
                                variant="outlined"
                                error={!frailtySDECForm.attention}
                            />
                        </Grid>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.fluctuation, "Fluctuation")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="fluctuation"
                                maxRows={25}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.fluctuation}
                                variant="outlined"
                                error={!frailtySDECForm.fluctuation}
                            />
                        </Grid>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.total, "Total")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="total"
                                maxRows={25}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.total}
                                variant="outlined"
                                error={!frailtySDECForm.total}
                            />
                        </Grid>
                        <Divider className={classes.divider}/>
                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.mood, "Mood")}
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="mood"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.mood}
                                variant="outlined"
                                error={!frailtySDECForm.mood}
                            />
                        </Grid>
                    </Grid>
                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.socialHistory}
                    onChange={()=>handleChangeAccordion("socialHistory")}
                    label="Social History"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <FormLabel className={classes.label}>{t("Accomodation")}</FormLabel>
                        </Grid>
                        <Grid item xs={6}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('accomodation', val)}
                                options={accommodationType}
                                value={frailtySDECForm.accomodation}
                                noBorder={false}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="accomodationText"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.accomodationText}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Stairs?")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="stairs"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.stairs}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio/>}
                                        label={t('No')}
                                    />
                                    <FormControlLabel
                                        value="lift"
                                        control={<Radio/>}
                                        label={t('Lift')}
                                    />
                                    <FormControlLabel
                                        value="stairlift"
                                        control={<Radio/>}
                                        label={t('Stairlift')}
                                    />
                                    <FormControlLabel
                                        value="bedDownstairs"
                                        control={<Radio/>}
                                        label={t('Bed downstairs')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("stairs")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={1}>
                            <FormLabel className={classes.label}>{t("Toilet")}</FormLabel>
                        </Grid>
                        <Grid item xs={5}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('toilet', val)}
                                options={toiletLocation}
                                value={frailtySDECForm.toilet}
                                noBorder={false}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <FormLabel className={classes.label}>{t("Bathroom")}</FormLabel>
                        </Grid>
                        <Grid item xs={5}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('bathroom', val)}
                                options={bathroomLocation}
                                value={frailtySDECForm.bathroom}
                                noBorder={false}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Lives with?")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('livesWith', val)}
                                options={livesWith}
                                value={frailtySDECForm.livesWith}
                                noBorder={false}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="socialHistoryText"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.socialHistoryText}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.mobilityAndTransfers}
                    onChange={()=>handleChangeAccordion("mobilityAndTransfers")}
                    label="Mobility And Transfers"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Life space")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="lifeSpace"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.lifeSpace}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Walking aid")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "walkingAid")}
                                        checked={frailtySDECForm.walkingAid.none}
                                        name="none"
                                    />
                                }
                                label="None"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "walkingAid")}
                                        checked={frailtySDECForm.walkingAid.stick}
                                        name="stick"
                                    />
                                }
                                label="Stick"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "walkingAid")}
                                        checked={frailtySDECForm.walkingAid.crutches}
                                        name="crutches"
                                    />
                                }
                                label="Crutches"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "walkingAid")}
                                        checked={frailtySDECForm.walkingAid.wheeled}
                                        name="wheeled"
                                    />
                                }
                                label="Wheeled Zimmer Frame/Walker"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "walkingAid")}
                                        checked={frailtySDECForm.walkingAid.ross}
                                        name="ross"
                                    />
                                }
                                label="Ross Return/Sara Stedy"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "walkingAid")}
                                        checked={frailtySDECForm.walkingAid.stand}
                                        name="stand"
                                    />
                                }
                                label="Stand aid"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "walkingAid")}
                                        checked={frailtySDECForm.walkingAid.hoist}
                                        name="hoist"
                                    />
                                }
                                label="Hoist"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "walkingAid")}
                                        checked={frailtySDECForm.walkingAid.bed}
                                        name="bed"
                                    />
                                }
                                label="Bed Bound"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Bed type")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('bedType', val)}
                                options={bedType}
                                value={frailtySDECForm.bedType}
                                noBorder={false}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Equipment")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="equipment"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.equipment}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Bed transfer issues?")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="bedTransferIssues"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.bedTransferIssues}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Chair type")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('chairType', val)}
                                options={chairType}
                                value={frailtySDECForm.chairType}
                                noBorder={false}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Difficulties?")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="difficulties"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.difficulties}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Toilet equipment")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="toiletEquipment"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.toiletEquipment}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.activitieOfDailyLiving}
                    onChange={()=>handleChangeAccordion("activitieOfDailyLiving")}
                    label="Activitie Of Daily Living"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Carers")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="carers"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.carers}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Agency")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="agency"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.agency}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Wash and dressing")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="washAndDressing"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.washAndDressing}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Toileting including continence")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="toiletingIncludingContinence"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.toiletingIncludingContinence}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Meals")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="meals"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.meals}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Shopping")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="shopping"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.shopping}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Domestic tasks")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="domesticTasks"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.domesticTasks}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Roles and occupation")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="rolesAndOccupation"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.rolesAndOccupation}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.additionalInformation}
                    onChange={()=>handleChangeAccordion("additionalInformation")}
                    label="Additional Information"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Care line")}</FormLabel>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="careLine"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.careLine}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio/>}
                                        label={t('No')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("careLine")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Key safe")}</FormLabel>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="keySafe"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.keySafe}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio/>}
                                        label={t('No')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("keySafe")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Code")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="code"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.code}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Pressure areas")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="pressureAreas"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.pressureAreas}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Pressure care in situ:")}</FormLabel>
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Mattress")}</FormLabel>
                        </Grid>
                        <Grid item xs={8}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="mattress"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.mattress}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Cushion")}</FormLabel>
                        </Grid>
                        <Grid item xs={8}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="cushion"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.cushion}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.communication}
                    onChange={()=>handleChangeAccordion("communication")}
                    label="Communication"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Hearing")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="hearing"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.hearing}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Vision")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="vision"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.vision}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Speech and language")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="speechAndLanguage"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.speechAndLanguage}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Preferred method of communication")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="preferredMethodOfCommunication"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.preferredMethodOfCommunication}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.dietNutritionAndSwallowing}
                    onChange={()=>handleChangeAccordion("dietNutritionAndSwallowing")}
                    label="Diet, Nutrition And Swallowing"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Height")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="height"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.height}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Weight")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="weight"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.weight}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("BMI")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="bmi"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.bmi}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Signs of visible weight loss")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="signsOfVisibleWeightLoss"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.signsOfVisibleWeightLoss}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Reduced appetite?")}</FormLabel>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="reducedAppetite"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.reducedAppetite}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio/>}
                                        label={t('No')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("reducedAppetite")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="reducedAppetiteText"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.reducedAppetiteText}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Reported swallowing difficulty")}</FormLabel>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="reportedSwallowingDifficulty"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.reportedSwallowingDifficulty}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio/>}
                                        label={t('No')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("reportedSwallowingDifficulty")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="reportedSwallowingDifficultyText"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.reportedSwallowingDifficultyText}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Food consistency")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('foodConsistency', val)}
                                options={foodConsistency}
                                value={frailtySDECForm.foodConsistency}
                                noBorder={false}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Fluids")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('fluids', val)}
                                options={fluids}
                                value={frailtySDECForm.fluids}
                                noBorder={false}
                            />
                        </Grid>
                    </Grid>
                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.vitalObservation}
                    onChange={()=>handleChangeAccordion("vitalObservation")}
                    label="Vital Observation"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <div className={classes.observations}>
                                <ObservationTable patient={props.patient}/>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div className={classes.observations}>
                                <ObservationTable patient={props.patient} abbeyPainScale apsLastObs/>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div className={classes.center}> {buttons()} </div>
                        </Grid>
                    </Grid>
                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.physicalExamination}
                    onChange={()=>handleChangeAccordion("physicalExamination")}
                    label="Physical Examination"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Physical examination")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "physicalExamination")}
                                        checked={frailtySDECForm.physicalExamination.jaundice}
                                        name="jaundice"
                                    />
                                }
                                label="Jaundice"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "physicalExamination")}
                                        checked={frailtySDECForm.physicalExamination.anaemia}
                                        name="anaemia"
                                    />
                                }
                                label="Anaemia"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "physicalExamination")}
                                        checked={frailtySDECForm.physicalExamination.clubbing}
                                        name="clubbing"
                                    />
                                }
                                label="Clubbing"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "physicalExamination")}
                                        checked={frailtySDECForm.physicalExamination.cyanosis}
                                        name="cyanosis"
                                    />
                                }
                                label="Cyanosis"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "physicalExamination")}
                                        checked={frailtySDECForm.physicalExamination.oedma}
                                        name="oedma"
                                    />
                                }
                                label="Oedma"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "physicalExamination")}
                                        checked={frailtySDECForm.physicalExamination.lyphadenopathy}
                                        name="lyphadenopathy"
                                    />
                                }
                                label="Lyphadenopathy"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("General comments")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="generalComments"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.generalComments}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.systems}
                    onChange={()=>handleChangeAccordion("systems")}
                    label="Systems"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Cardiovascular")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="cardiovascular"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.cardiovascular}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Respiratory")}</FormLabel>
                        </Grid>
                        <Grid item xs={2}>
                            <AgyleButton
                                color="primary"
                                variant="contained"
                                onClick={addBodyMap}
                                className={classes.buttonHeader}
                                startIcon={<AddIcon/>}
                            >
                                {t('Add Body Map')}
                            </AgyleButton>
                            <NewBodyMapNote
                                open={isBodyMapOpen}
                                onClose={handleCloseBodyMapEditor}
                                patient={props.patient}
                                setDefaultNoteType={setDefaultNoteType}
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="respiratoryText"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.respiratoryText}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Gastrointestinal")}</FormLabel>
                        </Grid>
                        <Grid item xs={2}>
                            <AgyleButton
                                color="primary"
                                variant="contained"
                                onClick={addBodyMap}
                                className={classes.buttonHeader}
                                startIcon={<AddIcon/>}
                            >
                                {t('Add Body Map')}
                            </AgyleButton>
                            <NewBodyMapNote
                                open={isBodyMapOpen}
                                onClose={handleCloseBodyMapEditor}
                                patient={props.patient}
                                setDefaultNoteType={setDefaultNoteType}
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="gastrointestinalText"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.gastrointestinalText}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Musculoskeletal")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="musculoskeletalText"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.musculoskeletalText}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Neurology")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="neurologyText"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.neurologyText}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Blood results")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="bloodResultsText"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.bloodResultsText}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.problems}
                    onChange={()=>handleChangeAccordion("problems")}
                    label="Problems"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.patientsPerceivedProblems, "Patient's Perceived Problems")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="patientsPerceivedProblems"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.patientsPerceivedProblems}
                                variant="outlined"
                                error={!frailtySDECForm.patientsPerceivedProblems}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.carersPerceivedProblems, "Carer's Perceived Problems")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="carersPerceivedProblems"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.carersPerceivedProblems}
                                variant="outlined"
                                error={!frailtySDECForm.carersPerceivedProblems}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.problemList, "Problem List")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="problemList"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.problemList}
                                variant="outlined"
                                error={!frailtySDECForm.problemList}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.treatmentPlanText, "Treatment Plan")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                noBorder={false}
                                fullWidth
                                name="treatmentPlanText"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.treatmentPlanText}
                                variant="outlined"
                                error={!frailtySDECForm.treatmentPlanText}
                            />
                        </Grid>
                    </Grid>
                </AgyleAccordion>
            </>
        )
}

export default FrailtySDECForm;